import {
  FETCH_SUCCESS,
  FETCH_START,
  FETCH_FAILURE,
  FETCH_INCIDENTS_FAILURE,
  FETCH_INCIDENTS_START,
  FETCH_INCIDENTS_SUCCESS,
  SHOW_INCIDENT,
  HIDE_INCIDENT,
  SELECT_EVENTS,
  CLEAR_SELECTION,
  NEXT_EVENT,
  PREV_EVENT,
  OPEN_EDITOR,
  CLOSE_EDITOR,
  SET_ADDRESS,
  SET_DESCRIPTION,
  SET_INCIDENT_ID,
  SET_POSITION,
  SET_SUBJECT,
  SET_ERROR,
  ADD_EVENT,
  EDIT_EVENT,
} from './actionTypes'

export const fetchSuccess = (events) => ({
  type: FETCH_SUCCESS,
  events,
})

export const fetchStart = () => ({
  type: FETCH_START,
})

export const fetchFail = (error) => ({
  type: FETCH_FAILURE,
  error,
})

export const fetchIncidentsSuccess = (incidents) => ({
  type: FETCH_INCIDENTS_SUCCESS,
  incidents,
})

export const fetchIncidentsStart = () => ({
  type: FETCH_INCIDENTS_START,
})

export const fetchIncidentsFail = (error) => ({
  type: FETCH_INCIDENTS_FAILURE,
  error,
})

export const showIncident = (incidentId) => ({
  type: SHOW_INCIDENT,
  incidentId,
})

export const hideIncident = (incidentId) => ({
  type: HIDE_INCIDENT,
  incidentId,
})

export const selectEvents = (eventIds) => ({
  type: SELECT_EVENTS,
  eventIds,
})

export const clearSelection = () => ({
  type: CLEAR_SELECTION,
})

export const nextEvent = () => ({
  type: NEXT_EVENT,
})

export const prevEvent = () => ({
  type: PREV_EVENT,
})

export const openEditor = (event) => ({
  type: OPEN_EDITOR,
  event,
})

export const closeEditor = () => ({
  type: CLOSE_EDITOR,
})

export const setIncidentId = (incidentId) => ({
  type: SET_INCIDENT_ID,
  incidentId,
})

export const setSubject = (subject) => ({
  type: SET_SUBJECT,
  subject,
})

export const setAddress = (address) => ({
  type: SET_ADDRESS,
  address,
})

export const setDescription = (description) => ({
  type: SET_DESCRIPTION,
  description,
})

export const setPosition = (longitude, latitude, address) => ({
  type: SET_POSITION,
  longitude,
  latitude,
  address,
})

export const setError = (error) => ({
  type: SET_ERROR,
  error,
})

export const addEvent = (event) => ({
  type: ADD_EVENT,
  event,
})

export const editEvent = (event) => ({
  type: EDIT_EVENT,
  event,
})
